"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Tue Mar 05 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author BPo
 */


var ForecastSimulationConflictDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ForecastSimulationConflictDTOConverter, _DataObjectConverter_);

  function ForecastSimulationConflictDTOConverter() {
    _classCallCheck(this, ForecastSimulationConflictDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationConflictDTOConverter).apply(this, arguments));
  }

  return ForecastSimulationConflictDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ForecastSimulationConflictDTOConverter = ForecastSimulationConflictDTOConverter;